import { useTranslation } from 'react-i18next';
import { Title3 } from "@components/new/Typo";
import { Modal, ModalSize } from "@components/new/Modal";
import PartnerIdImg from '@assets/img/partnerId.jpg';
import styles from "./PartnerIdInfoModal.module.scss";

interface PartnerIdInfoModalProps {
  onClose: () => void;
}

const PartnerIdInfoModal = ({ onClose }: PartnerIdInfoModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      className={styles.partnerIdModal}
      inModal
      isOpen={true}
      title={t('storesPage.partnerIdModal.title')}
      size={ModalSize.M}
      onClose={onClose}
      footerButtons={[
        {
          title: t('storesPage.partnerIdModal.okBtn'),
          onClick: onClose,
          isWide: true,
        },
      ]}
    >
      <Title3 color="grey-800">{t("storesPage.partnerIdModal.description")}</Title3>
      <img src={PartnerIdImg} />
    </Modal>
  )
}

export default PartnerIdInfoModal;
